import { axiosInstance } from './instance';
import type { ShiftDetails, SearchShiftsOutput } from './types/smithy';

export type { SearchShiftsOutput };

export const searchShifts = async (
  campusId: string,
  query?: string,
  offset?: number,
  limit?: number,
): Promise<SearchShiftsOutput> => {
  try {
    const searchQuery = query || campusId;
    const response = await axiosInstance.get('/shifts/search', {
      params: {
        query: searchQuery,
        offset,
        limit: limit || 100,
      },
    });

    // Filter to show only active shifts
    const filteredShifts = response.data.shifts?.filter((shift: ShiftDetails) => shift.status === 'ACTIVE') || [];

    return {
      shifts: filteredShifts,
    };
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch a shift by its ID
 * @param shiftId - The ID of the shift to fetch
 * @returns The shift details
 */
export const getShiftById = async (shiftId: string): Promise<ShiftDetails> => {
  try {
    const response = await axiosInstance.get(`/shifts/${shiftId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
